'use strict';

// Assigned Dependencies

module.exports = (function() {
    setupStickySideBar();
    setupTopMenu();
    setupMainNavItems();
    setupMobileMenu();
    enquire.register("screen and (max-width:1280px)", {
        match : function() {
            moveMenu(true);
        },
        unmatch: function() {
            moveMenu(false);
        }
    });
})();

function setupMainNavItems() {
    resetMobileMenus();

	$('.fat-nav').show();
    $('.fat-nav').find('.children').show();

    $('.nav-col > .main-nav > li > a').focus(function() {
        $('.nav-col > .main-nav > li').removeClass('focus');
        $(this).parent().addClass('focus');
    });

    $('.nav-col > .main-nav > li > a').blur(function() {
        if ($(this).siblings('.fat-nav').length == 0) {
            $(this).parent().removeClass('focus');
        }
    });

    $('.nav-col > .main-nav >.apply').click(function(event) {
        event.preventDefault();
        $(this).addClass('active');
        $('.mobile-menu-container').hide();
        $('.quick-apply-nav').slideDown().addClass('active');
        $('.mobile-menu-toggle').parent().removeClass('active');
        setTimeout(function(){
            moveWindowToElement('.quick-apply-nav',0,600);
        },80);
    });

    $('.quick-apply-toggle-button').click(function(e){
        e.preventDefault();
        $('.quick-apply-nav').slideUp();
        $('.nav-col > .main-nav >.apply').removeClass('active');
    });

    $(function(){
	    $('.mobile-menu-container ul.main-nav li a[href*="#"]').each(function() {
	    	$(this).click(function() {
		    	$(".mobile-menu-toggle").click();
	    	});
	    });
	});
}

function moveMenu(toMobile) {
    var mainMenu = $('.main-nav').detach();

    if (toMobile) {
        $('.mobile-navigation').empty().append(mainMenu);
        resetMobileMenus();
        setupMobileMenus();
    }
    else {
        if ($('.nav-col').length > 0) {
            $('.nav-col').empty().append(mainMenu);
            setupMainNavItems();
            $('.nav-col').find('li.has-children').removeClass('focus');
        }
        else if ($('.campaign-nav-col').length > 0) {
            $('.campaign-nav-col').empty().append(mainMenu);
        }
        $('.locations-menu').hide();
        $('.profile-menu').hide();
    }
    $(".mobile-menu-toggle").toggle($(".mobile-menu-container .mobile-navigation").children().length > 0);
}

function setupMobileMenu() {
    setupMobileMenuButton('.mobile-menu-toggle', '.mobile-menu');
    setupMobileMenuButton('.profile-menu-toggle', '.profile-menu');
    setupMobileMenuButton('.locations-menu-toggle', '.locations-menu');
}

function setupMobileMenuButton(button, menuContainer) {
    $(button).click(function(e) {
        e.preventDefault();
        var isActive = $(this).parent().hasClass('active');
        $('.buttons-col').find('button').parent().removeClass('active');
        $('.mobile-menu-container').slideUp();
        if (!isActive) {
            $(menuContainer).slideDown();
            $(this).parent().addClass('active');
        }
    });
}

function resetMobileMenus() {
    $('.mobile-nav-menu li.has-children > a').unbind('click');
    $('.mobile-nav-menu li.has-children .title').unbind('click');
    $('.footer-navigation-panel').find('.title').unbind('click');
    $('.footer-navigation-panel').find('.social').find('.title').unbind('click');

    $('.main-nav > li').removeAttr('style');
}

function setupMobileMenus() {
    resetMobileMenus();

    $('.mobile-nav-menu li.has-children > a').click(function(e){
        e.preventDefault();
        $(this).toggleClass('active');

        if ($(this).parent().find('.fat-nav').length > 0) {
            $(this).parent().find('.fat-nav').slideToggle();
            $(this).parent().find('.fat-nav').find('.children').hide();
        }
        else {
            $(this).next('.children').slideToggle();
        }
    });

    $('.mobile-nav-menu li.has-children .title').click(function(e){
        e.preventDefault();
        $(this).next('.children').slideToggle();
        $(this).toggleClass('active');
    });


    $('.footer-navigation-panel').find('.title').click(function() {
        var children = $(this).next('.children');

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(children).slideUp();
        }
        else {
            $(this).addClass('active');
            $(children).slideDown();
        }
    });

    $('.footer-navigation-panel').find('.social').find('.title').click(function() {
        var children = $('.footer-navigation-panel').find('.social').find('.children');
        var el =$('.footer-navigation-panel').find('.social').find('.title');
        if ($(el).hasClass('active')) {
            $(el).removeClass('active');
            $(children).slideUp();
        }
        else {
            $(el).addClass('active');
            $(children).slideDown();
        }
    });
}

function setupTopMenu() {
    $('.top-header, .main-navigation').find('.item').each(function() {
        $(this).hover(function() {

            if ($(this).find('ul').length > 0) {
                var width = $(this).outerWidth();
                var ulWidth = $(this).find('ul').outerWidth();
                var gap = ulWidth - width;
                var left =  parseFloat(-(gap/2));
                $(this).find('ul').css('left', left);
                $(this).find('ul').css('clip', 'auto');
                $(this).find('ul').css('clip-path', 'none');
            }
        },
        function(){
            if ($(this).find('ul').length > 0) {
                $(this).find('ul').css('clip-path', 'rect(0,0,0,0)');
                $(this).find('ul').css('clip-path', 'inset(50%)');
            }
        }
        );

        $(this).find('.item > a,button').focus(function(){
            $('.top-header, .main-navigation').find('.item').removeClass('focus');
            $(this).parent().addClass('focus');
        });

        $(this).find('.item > a,button').blur(function() {
            if ($(this).siblings('ul').length == 0) {
                $(this).parent().removeClass('focus');
            }
        });
    });

    $('.locations-toggle-button').click(function() {
        $('.header-locations').slideToggle();
        setTimeout(function(){
            moveWindowToElement('body',0,80);
        },80);
    });

    $('.top-header').find('.search-toggle-button').click(function(){
        $('.header-search-form').slideToggle();
        if ($('.header-search-form').is(':visible')) {
            $('.header-search-form').find('input[type="text"]').focus();
        }
        else {
            $('.header-search-form').find('input[type="text"]').blur();
        }
    });
}

function setupStickySideBar() {
	$(window).scroll(function() {
		var velocity = Math.min(window.scrollY/150, 1);
		$('.sticky-side-bar').css('top', lerp(35, 20, velocity).toPrecision(2) + "%");
	});

	function lerp(start, finish, progression) {
		return start + progression * (finish - start);
	}
}

function checkFilterSize(windowsize){
    if(windowsize < 1280){
        $('.mobile-left').removeClass('medium-4').addClass('medium-5');
        $('.mobile-spacing').removeClass('medium-3').addClass('medium-1');
        $('.mobile-filter').removeClass('medium-5').addClass('medium-6');

    } else {
        $('.mobile-left').removeClass('medium-5').addClass('medium-4');
        $('.mobile-spacing').removeClass('medium-1').addClass('medium-3');
        $('.mobile-filter').removeClass('medium-6').addClass('medium-5');
    }
}